import * as Styled from "./MapLayerItem.styled"

export const MapLayerItem = (props: MapLayerItemProps) => {

    const {
        image,
        title,
        isSelected = false,
        onClick,
    } = props

    return (
        <Styled.Wrapper onClick={onClick}>
            <Styled.Image background={image} isSelected={isSelected} />
            <Styled.Title variant="Desktop & Mobile/Body/Label & Helper text" isSelected={isSelected}>{title}</Styled.Title>
        </Styled.Wrapper>
    )
}

type MapLayerItemProps = {
    image: string
    title: string
    isSelected?: boolean
    onClick?: () => void
}
